import { Injectable } from '@angular/core'

interface QueryParams {
  [key: string]: string | null
}

@Injectable({
  providedIn: 'root'
})
export class QueryParamsService {
  private queryParams: QueryParams = {}
  private validKeys = [
    'uuid',
    'id',
    'clientId',
    'returnUrl',
    'userName',
    'lufu',
    'gender',
    'height',
    'weight',
    'age',
    'ethnicity',
    'smokingState',
    'smokingNumberOfYears',
    'smokingCigarettesPerDay',
    'inhalerType',
    'spirometryPreFev1',
    'spirometryPreFvc',
    'spirometryPostFev1',
    'spirometryPostFvc'
  ]

  // Method to set query parameters in the service
  public storeQueryParams(params: QueryParams): void {
    Object.keys(params).forEach(key => {
      if (this.validKeys.includes(key)) {
        this.queryParams[key] = params[key]
      }
    })
  }

  // Return the query parameters
  public getQueryParams(): QueryParams {
    return { ...this.queryParams }
  }

  // Return query param for given key
  public getQueryParam(key: string): string | null {
    return this.queryParams[key] ? this.queryParams[key] : null
  }

  public isQueryParam(key: string): boolean {
    const value = this.queryParams[key]
    return !!value
  }
}
